export const PersianNum = (num: number) => {
  try {
    return new Intl.NumberFormat("fa-IR").format(num);
  } catch (error) {
    return "";
  }
};

export const CheckNull = (value: any, check?: boolean) => {
  if (value == null || value == undefined) {
    if (check) {
      return "مهمان";
    } else {
      return "";
    }
  } else {
    return value;
  }
};

export const ConvertLink = (link: string) => {
  if (link) {
    return link.replace(/ /g, "-");
  } else {
    return "";
  }
};
export const ConvertLink2 = (link: string) => {
  return link.replace(/-/g, " ");
};

export const DiscountPercent = (price: number, discount: number) => {
  return Math.floor(((price - discount) / price) * 100);
};

export const ChangeDatePersian = (value: Date | string | number) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return new Intl.DateTimeFormat("fa-IR", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date);
};

export const convertPersianToEnglish = (text: string): string => {
  const numMap: { [key: string]: string } = {
    "۰": "0",
    "٠": "0",
    "۱": "1",
    "١": "1",
    "۲": "2",
    "٢": "2",
    "۳": "3",
    "٣": "3",
    "۴": "4",
    "٤": "4",
    "۵": "5",
    "٥": "5",
    "۶": "6",
    "٦": "6",
    "۷": "7",
    "٧": "7",
    "۸": "8",
    "٨": "8",
    "۹": "9",
    "٩": "9",
  };

  const convertedText = text
    .split("")
    .map((char) => numMap[char] || char)
    .join("");
  return convertedText;
};

export const PricePostSend = (count?: number) => {
  if (count && count >= 3) {
    return 60000;
  } else {
    return 40000;
  }
};

export const calculatePercentage = (value: number, total: number): number =>
  Number(((value / total) * 100).toFixed());

export const getTimeAgo = (dateString: any) => {
  const date: any = new Date(dateString);
  const now: any = new Date();
  const differenceInMilliseconds = now - date;

  const oneMinuteInMilliseconds = 60 * 1000;
  const oneHourInMilliseconds = 60 * oneMinuteInMilliseconds;
  const oneDayInMilliseconds = 24 * oneHourInMilliseconds;
  const oneMonthInMilliseconds = 30 * oneDayInMilliseconds;
  const oneYearInMilliseconds = 12 * oneMonthInMilliseconds;

  if (differenceInMilliseconds < oneDayInMilliseconds) {
    const hours = Math.floor(differenceInMilliseconds / oneHourInMilliseconds);
    if(hours === 0) return "چند دقیقه پیش"
    return `${PersianNum(hours)} ساعت پیش`;
  } else if (differenceInMilliseconds < oneMonthInMilliseconds) {
    const days = Math.floor(differenceInMilliseconds / oneDayInMilliseconds);
    return `${PersianNum(days)} روز پیش`;
  } else if (differenceInMilliseconds < oneYearInMilliseconds) {
    const months = Math.floor(
      differenceInMilliseconds / oneMonthInMilliseconds
    );
    return `${PersianNum(months)} ماه پیش`;
  } else {
    const years = Math.floor(differenceInMilliseconds / oneYearInMilliseconds);
    return `${PersianNum(years)} سال پیش`;
  }
};


type BadgeVariant = "default" | "secondary" | "destructive" | "outline";

/**
 * Returns a Badge variant based on the length of a string, useful for SEO fields.
 * @param value The string to check.
 * @param min The minimum optimal length.
 * @param max The maximum optimal length.
 * @returns 'default' (good), 'secondary' (warning), or 'destructive' (bad).
 */
export const getSeoStatusVariant = (value: string | undefined, min: number, max: number): BadgeVariant => {
  const length = value?.length || 0;
  if (length === 0) return "destructive"; // قرمز برای خالی بودن
  if (length >= min && length <= max) return "default"; // سبز (یا رنگ اصلی) برای حالت ایده‌آل
  return "secondary"; // خاکستری یا زرد برای حالتی که خارج از محدوده است اما خالی نیست
};
